import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  Paper,
  Modal,
  Tabs,
  Tab,
  Grid,
  IconButton,
  Card,
  CardContent,
  Link,
  Divider,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import RoomIcon from "@mui/icons-material/Room";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { Facebook, Instagram, LinkedIn,YouTube,WhatsApp } from '@mui/icons-material';

import { useEffect, useState } from "react";
import { socialMedia } from "../assets/Json/staticData";
import { contactUs } from "../store/contactUs/contactUsBaseApi";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../store/category/categoryBaseApi";

const ContactUs = (props) => {

  const dispatch= useDispatch();
  const { categories } = useSelector((state) => state.category);

  const [details, setDetails] = useState({
    name: "",
    email: "",
    phone: "",
    type: "",
    description: "",
  });
  const [error, setError] = useState({
    name: false,
    email: false,
    phone: false,
    type: false,
    description: false,
  });

  const contactDetails = [
    {
      icon: <RoomIcon fontSize="small" color="white" />,
      title: "Address",
      info: "NO 2 (First Floor)\n MILITARY LINE MOSQUE COMPLEX,\n(near SP office) \nPALAYAMKOTTAI, TIRUNELVELI, 627002",
      link:"https://www.google.com/maps/uv?pb=!1s0x3b041230d7393c21%3A0xd16bdc3410c38af2!3m1!7e115!4s%2Fmaps%2Fplace%2Fjb%2Barchitecture%2Btirunelveli%2F%408.7224508%2C77.7417221%2C3a%2C75y%2C342.12h%2C90t%2Fdata%3D*213m4*211e1*213m2*211sDh23ZWLheGj9g99NxtzvvA*212e0*214m2*213m1*211s0x3b041230d7393c21%3A0xd16bdc3410c38af2%3Fsa%3DX%26ved%3D2ahUKEwig46-LtrmMAxVZjGMGHdhnLS4Qpx96BAgCEAA!5sjb%20architecture%20tirunelveli%20-%20Google%20Search!15sCgIgAQ&imagekey=!1e2!2sDh23ZWLheGj9g99NxtzvvA&cr=le_a7&hl=en&ved=1t%3A206134&ictx=111"
    },
    {
      icon: <PhoneIcon fontSize="small" color="white" />,
      title: "Phone",
      info: "+91-8056707579",
      link:"tel:+918056707579"
    },
    {
      icon: <EmailIcon fontSize="small" color="white" />,
      title: "Email",
      info: "jbhassim93@gmail.com",
      link:"mailto:jbhassim93@gmail.com?subject=Design%20Details"
    },
  ];

  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails({
      ...details,
      [name]: value,
    });
    setError({
      ...error,
      [name]: value ? false : true,
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const formErrors = {};

    // Check for empty values
    Object?.keys(details)?.forEach((key) => {
      if (!details[key]) {
        formErrors[key] = true;
      }
    });
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(details.email)) {
      formErrors.email = true;
    }
    if (Object.keys(formErrors).length > 0) {
      setError(formErrors);
    } else {
       const resp = await dispatch(contactUs(details));
    if (resp.payload.success) {
      alert("success")
      
    } else {
    
      alert("fail")
    }
    }
  };
  return (
    <>
      <div>
     
            <div>

              <>
                <div className="row">
                  <div className="col-md-6">
                    <Box
                      sx={{
                        // backgroundColor: "#0d1b2a",
                        color: "#ffffff",
                        p: 4,
                        // minHeight: "100vh",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="black"
                        padding="20px"
                        align="center"
                      >
                        Contact Us
                      </Typography>
                      <Grid container spacing={4} justifyContent="center">
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            paddingTop: "20px",
                          }}
                        >
                          {contactDetails.map((detail, index) => (
                     
                            <Link 
                               href={detail?.link}  
                               target="_blank"
                               sx={{ display: "flex" }} key={index} >
                              
                              <IconButton
                                sx={{
                                  mb: 2,
                                  height: "50px",
                                  width: "50px",
                                  "&:hover": {
                                    backgroundColor: "gray",
                                    color: "white",
                                  },
                                }}
                              >
                                {detail?.icon}
                              </IconButton>
                             
                              <Typography color="black" padding={2}>
                                {detail.info}
                              </Typography>
                            </Link>
                          ))}
                        </Box>
                      </Grid>
                      <Button
                      className="btn btn-success"
                      href="https://wa.me/qr/RYGE52O4WS24I1"
                      target="_blank" 
                      rel="noopener noreferrer"
                      sx={{
                                      className:'z-2',    
                                       backgroundColor: '#128C7E',
                                       color:"white",
                                       width:"100%",
                                       fontSize:{xs:"50%",sm:"100%"},
                                    }}  startIcon={<WhatsApp />}>
                                      Connect with whatsapp
                                    </Button>
                      {/* <Button className="btn btn-success" variant="primary" sx={{width:"100%"}}><WhatsApp fontSize="small" color="white" /> Connect with whatsapp </Button> */}
                      <Divider sx={{ marginTop: "20px", color: "gray", fontSize: "10px" }}>
                        SOCIAL MEDIA
                      </Divider>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          marginTop: "20px",
                          justifyContent: "center",
                        }}
                      >
                        {socialMedia.map((data, idx) => {
                          if(data.title !== 'WhatsApp'){
                            return (
                              <IconButton
                                component="a"
                                href={data.info}
                                target="_blank"
                                key={idx}
                                sx={{
                                  backgroundColor: data.backgroundColor,
                                  color: "white",
                                  mb: 2,
                                  height: "40px",
                                  width: "40px",
                                  "&:hover": {
                                    backgroundColor: "gray",
                                    color: "white",
                                  },
                                }}
                              >
                                {data.icon.small}
                              </IconButton>
                            );
                          }
                        })}
                      </Box>
                    </Box>
                  </div>
                  <div className="col-md-6 map-container">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126197.54091768489!2d77.65928367861271!3d8.722553617967145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b041230d7393c21%3A0xd16bdc3410c38af2!2sJB%20Architects%20%26%20Engineers!5e0!3m2!1sen!2sin!4v1735364175884!5m2!1sen!2sin"
                      allowFullScreen
                      height="450px"
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </>
            {/* ) : ( */}
              <div className="">
                <div className="rounded border border-primary p-2">
                  <Typography variant="h6" textAlign="center">
                    Please Fill the below details we will contact you zoon!
                  </Typography>
                  <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit}
                  >
                    <div className="row">
                      <div className="col-md-6 mt-4">
                        <TextField
                          error={error?.name}
                          required
                          onChange={handleChange}
                          name="name"
                          id="outlined-error-helper-text"
                          label="First Name"
                          helperText={error?.name ? "Please Fill the name" : ""}
                          sx={{ width: "100%" }}
                          value={details?.name}
                        />
                      </div>
                      <div className="col-md-6 mt-4">
                        <TextField
                          error={error?.phone}
                          type="number"
                          required
                          onChange={handleChange}
                          name="phone"
                          label="Phone"
                          helperText={
                            error?.phone ? "Please Fill the Phone number" : ""
                          }
                          sx={{ width: "100%" }}
                          value={details?.phone}
                        />
                      </div>
                      <div className="col-md-6 mt-4">
                        <TextField
                          error={error?.email}
                          type="email"
                          required
                          onChange={handleChange}
                          name="email"
                          id="outlined-error-helper-text"
                          label="Email"
                          helperText={
                            error?.email ? "Please Fill the valid email" : ""
                          }
                          sx={{ width: "100%" }}
                          value={details?.email}
                        />
                      </div>

                      <div className="col-md-6 mt-4">
                            <FormControl sx={{ width:"100%" }} error={error?.type}>
      <InputLabel id="demo-select-small-label">Category</InputLabel>
                        <Select
                          required
                          labelId="demo-select-small-label"
                          id="outlined-error-helper-text"
                          label="Category"
                          name="type"
                          onChange={handleChange}
                          sx={{ width: "100%" }}
                          value={details?.type}
                          helperText={error?.type ? "Please Select Category" : ""}
                        >
                          {categories?.map((category,idx) => {
                            return <MenuItem value={category?.category} key={idx}>{category?.category}</MenuItem>
                          })}
                          {/* <MenuItem value="Interior">Interior</MenuItem>
                          <MenuItem value="Exterior">Exterior</MenuItem>
                          <MenuItem value="">None</MenuItem> */}
                        </Select>
                        {error?.type ?  <FormHelperText>Please Select Category</FormHelperText> : ""}
                       
    </FormControl>
    
                      </div>
                      <div className="col-md-12 mt-4">
                        <TextField
                          error={error?.description}
                          required
                          onChange={handleChange}
                          name="description"
                          id="outlined-error-helper-text"
                          label="Describe your project or need"
                          helperText={
                            error?.description
                              ? "Please add the description"
                              : ""
                          }
                          sx={{ width: "100%" }}
                          value={details?.description}
                          multiline
                          maxRows={4}
                        />
                      </div>
                      <div className="col-md-12 mt-4">
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{ width: "100%" }}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </Box>
                </div>
              </div>
            {/* )} */}
            </div>
      
      </div>
    </>
  );
};
export default ContactUs;
